import React, { Component } from 'react';
import { bool, string } from 'prop-types';
import { FormattedMessage } from '../../util/reactIntl';
import classNames from 'classnames';
import { propTypes } from '../../util/types';
import { obfuscatedCoordinates } from '../../util/maps';
import { Heading, Map } from '../../components';

import css from './ListingPage.module.css';

class SectionMapMaybe extends Component {
  constructor(props) {
    super(props);
    this.state = { isStatic: false, showMap: false };
  }

  render() {
    const {
      className,
      rootClassName,
      geolocation,
      publicData,
      listingId,
      mapsConfig,
      isOpen,
    } = this.props;
    // isOpen given: the toggle lives elsewhere (Details card "Show map"), so no heading here.
    const isControlled = typeof isOpen === 'boolean';
    const showMap = isControlled ? isOpen : this.state.showMap;

    if (!geolocation) {
      return null;
    }

    const address = publicData && publicData.location ? publicData.location.address : '';
    const classes = classNames(rootClassName || css.sectionMap, className);
    const cacheKey = listingId ? `${listingId.uuid}_${geolocation.lat}_${geolocation.lng}` : null;

    const mapProps = mapsConfig.fuzzy.enabled
      ? { obfuscatedCenter: obfuscatedCoordinates(geolocation, mapsConfig.fuzzy.offset, cacheKey) }
      : { address, center: geolocation };
    const map = <Map {...mapProps} useStaticMap={this.state.isStatic} />;

    if (isControlled && !isOpen) {
      return null;
    }

    return (
      <section className={classes} id="listing-location">
        {isControlled ? null : (
          <Heading as="h2" rootClassName={css.sectionMapTitle}
            onClick={() => {
              this.setState({ showMap: !this.state.showMap })
            }}>
            <FormattedMessage id={this.state.showMap ? "ListingPage.hideMap" : "ListingPage.showMap"} />
          </Heading>
        )}

        {showMap &&
          <>
            {this.state.isStatic ? (
              <button
                className={css.map}
                onClick={() => {
                  this.setState({ isStatic: false });
                }}
              >
                {map}
              </button>
            ) : (
              <div className={css.map}>{map}</div>
            )
            }
          </>
        }
      </section>
    );
  }
}

SectionMapMaybe.defaultProps = {
  rootClassName: null,
  className: null,
  geolocation: null,
  listingId: null,
  isOpen: undefined,
};

SectionMapMaybe.propTypes = {
  rootClassName: string,
  className: string,
  geolocation: propTypes.latlng,
  listingId: propTypes.uuid,
  isOpen: bool,
};

export default SectionMapMaybe;
